/** Shared between the browser bundle (subscribe.ts) and the Pages Function
 *  (functions/api/waitlist.ts) so client/server validation can't drift. */
export const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/
